// extracted by mini-css-extract-plugin
export default {"addressSection":"AQ-z","disabled":"BQ-z","sectionButtons":"CQ-z","logo":"DQ-z"};